import React from 'react';
import PropTypes from 'prop-types';

import {
    ReferenceInput,
    SelectInput,
    useRecordContext,
    useResourceContext,
} from 'react-admin';

import { Permissions } from '@src/global/permissions';

const FormAuthorInput = (props) => {
    const {
        isCreate,
        source,
    } = props;
    const record = useRecordContext();
    const resource = useResourceContext();
    const userName = (user) => `${user.first_name} ${user.last_name}`;

    if (isCreate) return null;

    return (
        <ReferenceInput
            required
            label="Author"
            source={source.authorId}
            resource={resource}
            record={record}
            reference="admins"
        >
            <SelectInput
                fullWidth
                emptyText="Select new admin"
                optionText={userName}
                disabled={Permissions(resource, 'update') !== true}
            />
        </ReferenceInput>
    );
};

FormAuthorInput.propTypes = {
    isCreate: PropTypes.bool,
    source: PropTypes.object.isRequired,
};

export default React.memo(FormAuthorInput);
